export default "__VITE_ASSET__D68k9B1X__"